import { render, staticRenderFns } from "./log_categories.vue?vue&type=template&id=3719333a&scoped=true"
import script from "./log_categories.vue?vue&type=script&lang=js"
export * from "./log_categories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3719333a",
  null
  
)

export default component.exports